import AuthWrapper from "./auth-wrapper.builder";
import authWrapperConfig from "./auth-wrapper.builder.config"

export default {
  config: authWrapperConfig,
  component: AuthWrapper,
};
